import { useMemo } from "react";

import useUser from "~/hooks/useUser";

function useQueryContextWithHasuraRole(rolePrefix) {
  const { user_roles: roles } = useUser();
  const context = useMemo(() => {
    const { role } = roles.find(({ role }) => role.name.startsWith(rolePrefix));
    return role
      ? {
          headers: {
            "x-hasura-role": role.name,
          },
        }
      : {};
  }, [roles, rolePrefix]);
  return context;
}

export default useQueryContextWithHasuraRole;
